import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  Background,
  FormWrapper,
  TextTitle,
  MessageText,
  QuestionText,
  ArgumentText,
  MarginBox,
  ButtonStyled
} from './Styled';
import CardNetwork, { NetworkProps } from './CardNetwork';
import Button from 'components/buttons/Button';
import NavigationLink from 'components/links/NavigationLink';
import { useSelector } from 'react-redux';
import { selectUserInfo } from 'redux/slices/userSlice';
import { ErrorAlert } from 'components/Alert';
import { selectCompany } from 'redux/slices/Company/CompanySlice';

const SocialNetwork = () => {
  const { t } = useTranslation(['social_network']);
  const history = useHistory();
  const { infoUser } = useSelector(selectUserInfo);
  const [updateError, setUpdateError] = useState<string | null>(null);
  const { company } = useSelector(selectCompany);

  const allNetworks: Array<NetworkProps> = [
    { network: 'facebook', linked: infoUser.linkedFacebook },
    { network: 'twitter', linked: infoUser.linkedTwitter },
    { network: 'linkedin', linked: infoUser.linkedLinkedin },
    { network: 'instagram', linked: infoUser.linkedInstagram },
    { network: 'tiktok', linked: infoUser.linkedTiktok }
  ];

  const networksBox: Array<NetworkProps> = company?.signUpSettings
    ?.networksToShow
    ? allNetworks.filter(network =>
        company.signUpSettings.networksToShow.includes(network.network)
      )
    : allNetworks;

  const linkedNetworkBox = networksBox.filter(
    network => network.linked == true
  );

  const continueDashboard = linkedNetworkBox.length > 0 ? 'primary' : 'default';

  const continueOnclick = () => {
    if (linkedNetworkBox.length > 0) {
      history.replace({ pathname: `/dashboard` });
    }
  };
  return (
    <>
      {updateError && (
        <ErrorAlert
          text={updateError}
          allowClose={true}
          onClose={() => setUpdateError(null)}
        />
      )}
      <Background>
        <FormWrapper>
          {!company?.signUpSettings?.skipSocialNetworks && (
            <NavigationLink
              text={t('social_network:skip')}
              direction="forward"
              to="/"
            />
          )}

          <TextTitle>
            <p>{t('social_network:welcome')}</p>
          </TextTitle>

          <MessageText>
            <p>
              {company?.signUpSettings?.title1 ||
                t('social_network:text_title')}
            </p>
          </MessageText>
          <QuestionText>
            <p>
              {company?.signUpSettings?.title2 ||
                t('social_network:question_networks')}
            </p>
          </QuestionText>

          <ArgumentText>
            <p>
              {company?.signUpSettings?.description ||
                t('social_network:argument')}
            </p>
          </ArgumentText>

          <MarginBox>
            <CardNetwork items={networksBox} setUpdateError={setUpdateError} />
          </MarginBox>
          <ButtonStyled>
            <Button
              value={t('social_network:continue')}
              variant={continueDashboard}
              onClick={continueOnclick}
            />
          </ButtonStyled>
        </FormWrapper>
      </Background>
    </>
  );
};

export default SocialNetwork;
